/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Title_1Inputs */

const en_svc_agents_title_1 = /** @type {(inputs: Svc_Agents_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom AI agents`)
};

const lv_svc_agents_title_1 = /** @type {(inputs: Svc_Agents_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pielāgoti AI aģenti,`)
};

/**
* | output |
* | --- |
* | "Custom AI agents" |
*
* @param {Svc_Agents_Title_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_title_1 = /** @type {((inputs?: Svc_Agents_Title_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Title_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_title_1(inputs)
	return en_svc_agents_title_1(inputs)
});